export const SUPPLIER_PAYMENT_MODE = ['cash', 'cheque', 'bank_transfer', 'mobile_wallet'];
export const SUPPLIER_PAYMENT_STATUS = ['pending_approval', 'paid', 'rejected', 'reversed'];
export const PURCHASE_RETURN_REASON = ['expired', 'damaged', 'recalled', 'wrong_item', 'overstock', 'other'];
export const BATCH_STATUS = ['active', 'quarantined', 'recalled'];
export const STOCK_LOSS_CATEGORY = ['expired', 'damaged', 'theft', 'other'];
export const STOCK_ADJUSTMENT_REQUEST_STATUS = ['pending', 'approved', 'rejected', 'cancelled'];
export const STOCK_ADJUSTMENT_SOURCE = ['manual', 'stock_take'];
export const STOCK_TAKE_STATUS = ['open', 'closed', 'cancelled'];
export const STOCK_TAKE_LINE_STATUS = ['pending', 'counted', 'disputed'];
export const STOCK_BATCH_EVENT_KIND = ['quarantine', 'release', 'recall', 'reprice'];
export const AGEING_BUCKET_LIMITS_DAYS = [30, 60, 90];
export const GRN_PRICE_VARIANCE_WARN_PCT = 10;
export const GRN_BACKDATED_WARN_DAYS = 7;
export const MAX_STOCK_TAKE_LINES = 2000;
export const WASTAGE_ACCOUNT_CODE = '5150';
export const WASTAGE_ACCOUNT_NAME = 'Stock Loss / Wastage';
export const PRICE_VARIANCE_ACCOUNT_CODE = '5160';
export const PRICE_VARIANCE_ACCOUNT_NAME = 'Purchase Price Variance';
export const MAX_LINE_TOTAL_MINOR = 10_000_000_000;
export const MAX_DOCUMENT_TOTAL_MINOR = 10_000_000_000_000;
export const EXPORT_ROW_LIMIT = 20_000;
export const SUPPLIER_LEDGER_SOURCES = ['grn', 'grn_void', 'purchase_return', 'supplier_payment', 'supplier_payment_reversal'];
//# sourceMappingURL=procurement.js.map